import { CSSObject, css } from '@emotion/react'
import {
  Typography,
  Spacing,
  Color,
  Theme,
  cssVar,
  ThemedColors,
  gemVar,
} from '@opallabs/gem'

export const messageClass = 'add-to-plan-message'

export const heightValues = {
  checkbox: 41,
  singleSelect: 61,
  twoLineMessage: 74,
  margin: Spacing.M,
}

export const getLoaderHeight = ({
  invalidMomentCount,
  momentCount,
  limitOptions,
}: {
  invalidMomentCount: number
  momentCount: number
  limitOptions?: boolean
}) => {
  const hasValidMoments = invalidMomentCount !== momentCount
  const hasInvalidMoments = Boolean(invalidMomentCount)
  const baseHeight = limitOptions
    ? heightValues.singleSelect
    : heightValues.singleSelect + heightValues.checkbox

  if (hasInvalidMoments) {
    if (hasValidMoments) {
      return baseHeight + heightValues.twoLineMessage + heightValues.margin
    }

    return heightValues.twoLineMessage
  }

  return baseHeight
}

export const errorText = (theme: Theme) => ({
  ...Typography.T300,
  color: Color[theme].Text.Warning,
})

export const checkboxGroup = (hasError: boolean) =>
  css({
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'row nowrap',
    marginTop: hasError ? Spacing.XS : Spacing.L - 3 + Spacing.XS,
  })

export const checkboxLabelOverrides = (theme: Theme): CSSObject => ({
  cursor: 'pointer',
  lineHeight: '16px',
  marginLeft: Spacing.XS * 3,
  color: theme === 'light' ? Color[theme].Text.Gray : '#959799',
})

export const linkStyles = css({
  display: 'block',
  width: '100%',
})

export const modalContent = css({
  overflow: 'visible',

  '.lapidary-modal-body': {
    marginBlockStart: 36,
  },
})

export const modalBody = css({
  overflow: 'inherit',

  [`.${messageClass} + .lapidary-multi-select`]: {
    marginBlockStart: Spacing.M,
  },
})

export const singleMessageContainer = css({
  ...Typography.T500,
  alignItems: 'center',
  backgroundColor: gemVar(ThemedColors.Surface2),
  borderRadius: Spacing.XS,
  color: gemVar(ThemedColors.TextSecondary),
  display: 'flex',
  flexDirection: 'column',
  gap: Spacing.XS,
  justifyContent: 'center',
  padding: Spacing.M,
  textAlign: 'center',
})

export const bulkMessageContainer = css({
  ...Typography.T500,
  backgroundColor: gemVar(ThemedColors.Surface2),
  borderRadius: Spacing.XS,
  color: gemVar(ThemedColors.TextSecondary),
  padding: Spacing.M,

  span: {
    color: cssVar(ThemedColors.TextLinks),
    '&:hover': {
      cursor: 'pointer',
    },
  },
})

export const footer = css({
  alignItems: 'center',
  columnGap: 0,
  justifyContent: 'space-between',
})

export const footerButtons = css({
  display: 'flex',
  columnGap: 12,
})

export const selectionText = css({
  color: cssVar(ThemedColors.TextSecondary),
  marginBlockEnd: 0,
})
